import React from 'react';
import { debounce } from '../utils';

const useContainerSize = (
	targetRef: React.MutableRefObject<HTMLDivElement | HTMLUListElement | HTMLLIElement>,
	delay: number = 300
) => {
	const [dimensions, setDimensions] = React.useState({ width: 0, height: 0 });

	const test = () => {
		if (targetRef.current) {
			setDimensions({
				width: targetRef.current.offsetWidth,
				height: targetRef.current.offsetHeight
			});
		}
	};

	React.useLayoutEffect(() => {
		test();
		const debouncedTest = debounce(test, delay);
		window.addEventListener('resize', debouncedTest);
		return () => {
			window.removeEventListener('resize', debouncedTest);
		};
	}, [targetRef.current]);

	return dimensions;
};

export { useContainerSize };
